// import { supportedLanguages } from "@acme/i18n";
import type { SupportedLanguage } from "@acme/i18n";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@acme/ui/select";
import { useLanguage } from "~/common/hooks/use-language.js";

interface Language
{
  code: SupportedLanguage;
  name: string;
  flag: string;
}

const languages: Language[] = [
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "de", name: "Deutsch", flag: "🇩🇪" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
];

export const LanguageSwitcher = () =>
{
  const { currentLanguage, changeLanguage } = useLanguage();

  return (
    <div className="mb-6">
      <Select
        value={currentLanguage}
        onValueChange={(value) =>
        {
          const newLanguage = value as SupportedLanguage;
          changeLanguage(newLanguage);
        }}>
        <SelectTrigger>
          <SelectValue>
            {(() =>
            {
              const sel = languages.find((l) => l.code === currentLanguage) || languages[0];
              return (
                <span className="inline-flex items-center gap-2">
                  <span>{sel.flag}</span>
                  <span>{sel.name}</span>
                </span>
              );
            })()}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {languages.map(({ code, name, flag }) => (
            <SelectItem key={code} value={code}>
              <span className="inline-flex items-center gap-2">
                <span>{flag}</span>
                <span>{name}</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export const AdvancedLanguageSwitcher = () =>
{
  const { currentLanguage, changeLanguage } = useLanguage();

  return (
    <div className="inline-flex rounded-lg border border-gray-300 p-1">
      {languages.map(({ code, name, flag }) => (
        <button
          key={code}
          onClick={() => changeLanguage(code)}
          className={`
            px-3 py-1 rounded transition-colors
            ${currentLanguage === code ? "bg-blue-500 text-white" : "hover:bg-gray-100"}
          `}>
          <span className="mr-1">{flag}</span>
          <span className="text-sm">{name}</span>
        </button>
      ))}
    </div>
  );
};
